import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';

import {StorageService} from "./storage";
import {ConfigService} from "./config-service";

@Injectable()
export class GetNewsService {
  server: string;
  currentServerId: string;
  jsessionid: string;


  constructor(
    public http: Http,
    public stg: StorageService,
    public cnf: ConfigService
  ) {}

  login(force = false) {
    this.generateServerUrl();
    const options = {
      params: {
        login: this.stg.get('username' + this.currentServerId),
        passw: this.stg.get('password' + this.currentServerId),
        forceconnect: force ? '1' : '0',
        uuid: '1',
        time: new Date().getTime() + '',
        Kookie: 'false'
      }
    };
    const url = this.server + 'Auth';
    return this.http.get(url, options)
      .map((data) => {
        //console.log(data);
        return data.json();
      });
  }

  logout() {
    return this.http.get(this.server + 'Logout' + this.stg.get('jsessionid')).map(data => data.json());
  }

  info() {
    return this.http.get(this.server + 'Info' + this.stg.get('jsessionid')).map(data => data.json());
  }

  getTitlesList(newsID: number[]) {
    // let params = new URLSearchParams();
    // params.set('newsID', newsID.join(';'));
    // params.set('preview', 'false');
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'GetTitlesList' + this.stg.get('jsessionid'),
      {
        params:
          {
            newsID: newsID.join(';'),
            preview: 'false',
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  getNews(id: number, keywords) {
    // let params = new URLSearchParams();
    // params.set('id', String(id));
    // params.set('keywords', keywords);
    // params.set('jsessionid', this.storageService.get('jsessionid'));
    // params.set('getKeywordsFromPos', 'true');
    return this.http.get(this.server + 'GetNews' + this.stg.get('jsessionid'),
      {
        params:
          {
            id: String(id),
            keywords: keywords,
            jsessionid: this.stg.get('jsessionid'),
            getKeywordsFromPos: 'true'
          }
      });
  }

  getNewsT(id: number) {

    // let params = new URLSearchParams();
    // params.set('id', String(id));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'GetNewsT' + this.stg.get('jsessionid'),
      {
        params: {
          id: String(id),
          jsessionid: this.stg.get('jsessionid')
        }
      }).map(data => data.json());
  }

  saveSettings(showKeywords, foreAlarm, textSize, titleSize) {
    // let params = new URLSearchParams();
    // params.set('showKeywords', String(showKeywords));
    // params.set('foreAlarm', String(foreAlarm));
    // params.set('textSize', String(textSize));
    // params.set('titleSize', String(titleSize));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'SaveSettings' + this.stg.get('jsessionid'),
      {
        params: {
          showKeywords: String(showKeywords),
          foreAlarm: String(foreAlarm),
          textSize: String(textSize),
          titleSize: String(titleSize),
          jsessionid: this.stg.get('jsessionid')
        }
      }).map(data => data.json());
  }

  sendKeywords() {
    // let params = new URLSearchParams();
    // params.set('action', 'sendkeywords');
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'sendkeywords',
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  getKeywords() {
    // let params = new URLSearchParams();
    // params.set('action', 'getkeywords');
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'getkeywords',
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  addKeywords(keyword) {
    // let params = new URLSearchParams();
    // params.set('action', 'addkeyword');
    // params.set('color', keyword.color);
    // params.set('enabled', String(keyword.enabled ? 1 : 0));
    // params.set('keyword', String(keyword.key));
    // params.set('tag', String(keyword.tag));
    // params.set('caseSensitive', String(keyword.caseSensitive));
    // params.set('alarm', String(1));
    // params.set('print', String(0));
    // params.set('push_enabled', String(keyword.mobilePush));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params: {
          action: 'addkeyword',
          color: keyword.color,
          enabled: String(keyword.enabled ? 1 : 0),
          keyword: String(keyword.key),
          tag: String(keyword.tag),
          caseSensitive: String(keyword.caseSensitive),
          alarm: String(1),
          print: String(0),
          push_enabled: String(keyword.mobilePush),
          jsessionid: this.stg.get('jsessionid')
        }
      }).map(data => data.json());
  }

  editKeyword(id, keyword) {
    // let params = new URLSearchParams();
    // params.set('action', 'editkeyword');
    // params.set('id', String(id));
    // params.set('color', keyword.color);
    // params.set('enabled', String(keyword.enabled ? 1 : 0));
    // params.set('keyword', String(keyword.key));
    // params.set('tag', String(keyword.tag));
    // params.set('caseSensitive', String(keyword.caseSensitive));
    // params.set('alarm', String(1));
    // params.set('print', String(0));
    // params.set('push_enabled', String(keyword.mobilePush));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'editkeyword',
            id: String(id),
            color: keyword.color,
            enabled: String(keyword.enabled ? 1 : 0),
            keyword: String(keyword.key),
            tag: String(keyword.tag),
            caseSensitive: String(keyword.caseSensitive),
            alarm: String(1),
            print: String(0),
            push_enabled: String(keyword.mobilePush),
            jsessionid: this.stg.get('jsessionid'),
          }
      }).map(data => data.json());
  }

  deleteKeyword(id) {
    // let params = new URLSearchParams();
    // params.set('action', 'deletekeyword');
    // params.set('id', String(id));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'deletekeyword',
            id: String(id),
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  getAgencyEnablings() {
    // let params = new URLSearchParams();
    // params.set('action', 'getagencyenablings');
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'getagencyenablings',
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  saveAgencyEnablings(agencies) {
    // let params = new URLSearchParams();
    // params.set('action', 'saveagencyenablings');
    // params.set('enablings', agencies.join(';'));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'saveagencyenablings',
            enablings: agencies.join(';'),
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  getAgencyGlobals() {
    // let params = new URLSearchParams();
    // params.set('action', 'getagencyglobals');
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params:
          {
            action: 'getagencyglobals',
            jsessionid: this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  saveAgencyGlobals(agencies) {
    // let params = new URLSearchParams();
    // params.set('action', 'saveagencyglobals');
    // params.set('enablings', agencies.join(';'));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'Keywords' + this.stg.get('jsessionid'),
      {
        params: {
          action: 'saveagencyglobals',
          enablings: agencies.join(';'),
          jsessionid: this.stg.get('jsessionid')
        }
      }
    ).map(data => data.json());
  }

  public getMenu() {
    const options = {
      params: {
        id: '0',
        jsessionid: this.stg.get('jsessionid')
      }
    };
    const url = this.server + 'getMenu' + this.stg.get('jsessionid');
    return this.http.get(url, options)
      .map((data: any) => {
        return data.json();
      });
  }

  openNewWindow() {
    // let params = new URLSearchParams();
    // params.set('jsessionid', this.storageService.get('jsessionid'));
    // params.set('Keywords', 'true');

    return this.http.get(this.server + 'openNewWindow' + this.stg.get('jsessionid'),
      {
        params:
          {
            'jsessionid': this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  closeWindow(winHD: number) {
    // let params = new URLSearchParams();
    // params.set('winHD', String(winHD));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'closeWindow' + this.stg.get('jsessionid'),
      {
        params:
          {
            'winHD': String(winHD),
            'jsessionid': this.stg.get('jsessionid')
          }
      }).map(data => data.json());
  }

  public selectMenu(winHD: number, menu: string) {
    const options = {
      params: {
        'winHD': String(winHD),
        'menu': menu,
        'jsessionid': this.stg.get('jsessionid')
      }
    }
    const url = this.server + 'selectMenu' + this.stg.get('jsessionid');
    return this.http.get(url, options).map((data: any) => {
      return data.json();
    });

  }

  getNewsReferences(winHD: number, from: number, max: number) {
    // let params = new URLSearchParams();
    // params.set('winHD', String(winHD));
    // params.set('from', String(from));
    // params.set('max', String(max));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'getNewsReferences' + this.stg.get('jsessionid'),
      {
        params: {
          'winHD': String(winHD),
          'from': String(from),
          'max': String(max),
          'jsessionid': this.stg.get('jsessionid')
        }
      }).map(data => data.json());

  }

  search(winHD: number, fromDate: string, toDate: string, exp: string, isArchive: boolean) {
    // let params = new URLSearchParams();
    // params.set('winHD', String(winHD));
    // params.set('fromDate', String(fromDate));
    // params.set('toDate', String(toDate));
    // params.set('exp', String(exp));
    // params.set('isArchive', String(isArchive));
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'search' + this.stg.get('jsessionid'),
      {
        params: {
          'winHD': String(winHD),
          'fromDate': String(fromDate),
          'toDate': String(toDate),
          'exp': String(exp),
          'isArchive': String(isArchive),
          'jsessionid': this.stg.get('jsessionid')
        }
      }).map(data => data.json());

  }

  selectDate(winHD: number, date: string) {
    // let params = new URLSearchParams();
    // params.set('winHD', String(winHD));
    // params.set('date', String(date));
    // params.set('backward', 'false');
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'selectDate' + this.stg.get('jsessionid'),
      {
        params:
          {
            'winHD': String(winHD),
            'date': String(date),
            'backward': 'false'
          }
      }).map(data => data.json());
  }

  getUrlLogos() {
    // let params = new URLSearchParams();
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'getUrlLogos' + this.stg.get('jsessionid'),
      {
        params: {
          'jsessionid': this.stg.get('jsessionid')
        }
      }).map(data => data.json());
  }

  windowsStatus() {
    // let params = new URLSearchParams();
    // params.set('jsessionid', this.storageService.get('jsessionid'));

    return this.http.get(this.server + 'WindowStatus' + this.stg.get('jsessionid'), {
      params: {
        'jsessionid': this.stg.get('jsessionid')
      }
    }).map(data => data.json());
  }

  generateProtocol() {
    if (this.stg.get('ssl' + this.currentServerId) === 'true') {
      return 'https';
    } else {
      return 'http';
    }
  }

  public generateBaseUrl() {
    this.currentServerId = this.stg.get('currentServer');
    if (parseInt(this.currentServerId) === 1) {
      if (this.cnf.forceServer1Protocol) {
        return this.cnf.server1Protocol() + '://' + this.stg.get('hostname' + this.currentServerId)
      } else {
        return this.generateProtocol() + '://' + this.stg.get('hostname' + this.currentServerId)
      }
    } else if (parseInt(this.currentServerId) === 2) {
      if (this.cnf.forceServer2Protocol) {
        return this.cnf.server2Protocol() + '://' + this.stg.get('hostname' + this.currentServerId)
      } else {
        return this.generateProtocol() + '://' + this.stg.get('hostname' + this.currentServerId)
      }
    } else {
      return null;
    }
  }

  private generateServerUrl() {
    if (typeof this.stg.get('currentServer') === 'undefined') {
      this.server = null;
    } else {
      this.server = this.generateBaseUrl() + '/GetNewsServ/';
    }
  }

  registerDevice() {
    let time = new Date().getTime();
    // let params = new URLSearchParams();
    if (typeof this.stg.get('pushEnabled') === 'undefined') {
      this.stg.set('pushEnabled', true);
    }

    // params.set('uid', this.storageService.get('token'));
    // if (this.cnf.appVersion == 'rai') {
    //   params.set('app', 'getnews-rai');
    // } else {
    //   params.set('app', 'getnews');
    // }
    // params.set('username', this.storageService.get('username'));
    // params.set('platform', 'getnews');
    // params.set('target', 'getnews');
    // params.set('time', String(time));
    // params.set('version', this.storageService.get('app_version'));
    // params.set('push_enabled', this.storageService.get('pushEnabled'));

    this.http.post('http://push.leevee.it/getnews/register_device.json',
      {
        'uid': this.stg.get('token'),
        'app': 'getnews',
        'username': this.stg.get('userId'),
        'platform': 'getnews',
        'target': 'getnews',
        'time': String(time),
        'version': this.stg.get('app_version'),
        'push_enabled': this.stg.get('pushEnabled'),
        'serv_id': this.stg.get('servId')
      }).subscribe(
      (response) => {
        // console.log('Push: Registration OK');
        // console.log(response);
      },
      (response) => {
        // console.log('Push: Registration Error');
        // console.log(response);
      });
  }

  goTo(newsId) {
    // let params = new URLSearchParams();
    // params.set('winHD', '1');
    // params.set('newsID', newsId);

    return this.http.get(this.server + 'goTo' + this.stg.get('jsessionid'),
      {
        params: {
          'winHD': '1',
          'newsID': newsId
        }
      }).map(data => data.json());

  }

}



// WEBPACK FOOTER //
// ./src/providers/get-news-service.ts